export enum CouponStepsView {
  AVAILABLE = 'Disponibles',
  ASSIGNED = 'Asignados',
  USED = 'Usados',
}
